'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _iBem = require('../../i-bem/i-bem.react');

var _bLinkMThemeNormal = (require('./../../link/link.react.js').default || require('./../../link/link.react.js')).applyDecls();

var _bLinkMThemeNormal2 = _interopRequireDefault(_bLinkMThemeNormal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)({
    block: 'footer',
    elem: 'link',
    render: function render() {
        var props = this.props,
            block = this.block,
            elem = this.elem;

        var linkProps = _extends({ theme: 'normal', size: 'm', mix: { block: block, elem: elem } }, props);

        return _react2.default.createElement(_bLinkMThemeNormal2.default, linkProps);
    }
});